import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { type ResponseError, fetchApiWithToken } from '../utils'

type EmailTemplate = {
  id: number
  name: string
  subject: string
  content: string
}

export const useEmailTemplates = (): UseQueryResult<
  EmailTemplate[],
  ResponseError
> =>
  useQuery({
    queryKey: ['emails', 'templates'],
    queryFn: async () =>
      await fetchApiWithToken({
        method: 'get',
        url: '/v1/templates?itemsPerPage=999'
      }),
    refetchOnWindowFocus: false,
    staleTime: 1800_000
  })

export type EmailTemplateAttachment = {
  id: number
  object: {
    id: number
    uri: string
    filename: string | null
    size: number | null
  }
}

export const useEmailTemplateAttachments = (
  templateId?: number | null
): UseQueryResult<EmailTemplateAttachment[], ResponseError> =>
  useQuery({
    queryKey: ['emails', 'templates', templateId, 'attachments'],
    queryFn: async () =>
      await fetchApiWithToken({
        method: 'get',
        url: `/v1/templates/${templateId}/attachments`
      }),
    refetchOnWindowFocus: false,
    enabled: !!templateId,
    staleTime: 1800_000
  })
